import classNames from 'classnames';
import type React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { Spacer } from '../../Spacer';

export interface CheckboxProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  label?: React.ReactNode;
  name: string;
  disabled?: boolean;
  value?: string;
  indeterminate?: boolean;
}

export const Checkbox = ({
  name,
  label,
  onChange,
  checked = false,
  disabled,
  value = '',
  indeterminate = false,
}: CheckboxProps) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checked && indeterminate && checkboxRef?.current) {
      checkboxRef.current.indeterminate = indeterminate;
    } else {
      checkboxRef.current.indeterminate = false;
    }
  }, [indeterminate, checked]);

  const style = {
    backgroundImage:
      (disabled && checked) || (checked && !indeterminate)
        ? `url(
            "data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e"
          )`
        : '',
  };

  return (
    <label
      id={name}
      className={classNames([
        'inline-flex items-center',
        !disabled && 'cursor-pointer',
      ])}
    >
      <input
        ref={checkboxRef}
        disabled={disabled}
        type="checkbox"
        name={name}
        value={value}
        className={classNames([
          `
          rounded-sm
            border
            outline-none
            active:outline-none
            active:ring-0
            active:ring-offset-0
            focus:outline-none
            focus:ring-0
            focus:ring-offset-0`,
          disabled && !checked
            ? 'border-ds-natural-200 text-ds-natural-200-a bg-ds-natural-200-a'
            : disabled && checked
              ? 'filter contrast-50 border-transparent text-ds-natural-200-a checked:bg-75'
              : checked
                ? 'hover:text-ds-primary-400 text-ds-primary active:text-ds-primary-500 cursor-pointer'
                : `cursor-pointer
                 text-ds-primary
                 border-ds-natural-200
                 hover:border-ds-primary-400
                 active:border-ds-primary-500
                 `,
          indeterminate && checked && 'bg-ds-primary-300',
        ])}
        onChange={onChange}
        checked={checked}
        style={style}
      />

      {label && (
        <>
          <Spacer amount={0.5} />
          <div
            className={classNames([
              'inline-block',
              !disabled && 'cursor-pointer',
            ])}
          >
            {label}
          </div>
        </>
      )}
    </label>
  );
};
